import { postFetch } from "./utilidades/postFetch";
import { Report } from "notiflix/build/notiflix-report-aio";
import { selectCidades } from "./utilidades/selectCidades";
import { buscaCep } from "./utilidades/buscaCep";
import { buscaCnpj } from "./utilidades/buscaCnpj";
import IMask from "imask";
import { selectCidadesTomSelect } from "./utilidades/selectCidades";
import { configurarTelefoneInput } from "./utilidades/configurarTelefoneInputPlugins";
import { getNumeroDialCodePorHtmlIntlTel } from "./utilidades/getTelefoneDialCodePorHtmlIntlTel";
import JustValidate from "just-validate";
import { loadFullPage } from "./utilidades/loadFullPage";
import i18next from "i18next";
import { inicializarInternacionalizacao } from './localizacao/hotsite-empresa/hotsite-empresa';

const empresaCliente = {
    async salvar(form) {
    const formData = new FormData(form);

    const callbackSucesso = () => {
        loadFullPage.esconder();
        window.location.href =
        "/" + CULTURE_EMPREGARE + "/empresa/cadastro-recebido";
    };

    const callbackErroConexao = () => {
        loadFullPage.esconder();
    };

    const callbackErro = (resultado) => {
        loadFullPage.esconder();

        Report.init({
        failure: {
            svgColor: "#ff5549",
            titleColor: "#1e1e1e",
            messageColor: "#242424",
            buttonBackground: "#ff5549",
            buttonColor: "#fff",
            backOverlayColor: "rgba(225,225,245,.4)",
        },
        });
        Report.failure("Ocorreu um erro", resultado.mensagem, "Ok");
    };

    loadFullPage.mostrar();
    await postFetch(
        `/${CULTURE_EMPREGARE}/HotSiteEmpresa/Register`,
        formData,
        callbackSucesso,
        callbackErro,
        callbackErroConexao
    );
    },
    justValidateConfig(form) {
    const formValidar = new JustValidate(form, {
        errorFieldCssClass: "is-invalid",
    });

    formValidar
        .addField("#Nome", [
        { rule: "required", errorMessage: i18next.t('FormValidationNomeEmpresaRequired') },
        {
            rule: "maxLength",
            value: 150,
            errorMessage: i18next.t('FormValidationNomeEmpresaMax'),
        },
        ])
        .addField("#CpfCnpj", [
        {
            rule: "maxLength",
            value: 18,
            errorMessage: i18next.t('FormValidationNomeCNPJMax'),
        },
        ])
        .addField("#Telefone", [
        { rule: "required", errorMessage: i18next.t('FormValidationTelefoneRequired')},
        {
            rule: "maxLength",
            value: 15,
            errorMessage: i18next.t('FormValidationTelefoneMax'),
        },
        ])
        .addField("#Responsavel", [
        { rule: "required", errorMessage: i18next.t('FormValidationResponsavelRequired')},
        {
            rule: "maxLength",
            value: 100,
            errorMessage: i18next.t('FormValidationResponsavelMax'),
        },
        ])
        .addField("#Email", [
        { rule: "required", errorMessage: i18next.t('FormValidationEmailRequired')},
        {
            rule: "email",
            errorMessage: i18next.t('FormValidationEmailInvalid'),
        },
        ])
        .addField("#paisID", [
        { rule: "required", errorMessage: i18next.t('FormValidationPaisRequired')},
        ])
        .addField("#estadoID", [
        { rule: "required", errorMessage: i18next.t('FormValidationEstadoRequired')},
        ])
        .addField("#cidadeID", [
        { rule: "required", errorMessage: i18next.t('FormValidationCidadeRequired')},
        ])
        .addField("#Cep", [{ rule: "required", errorMessage: i18next.t('FormValidationCEPRequired')}])
        .addField("#Descricao", [
        {
            rule: "maxLength",
            value: 500,
            errorMessage: i18next.t('FormValidationDescricaoMax'),
        },
        ]);

    form.addEventListener("submit", (e) => {
        e.preventDefault();

        formValidar.revalidate().then((isValid) => {
        if (!isValid) {
            return;
        }
        this.salvar(form);
        });
    });
    },
    maskConfig(form) {
    const cnpjInput = form.querySelector("#CpfCnpj");
    const cnpjMaskOptions = {
        mask: "SS.SSS.SSS/SSSS-00",
        definitions: { S: /[A-Za-z0-9]/ },
        prepare: (str) => str.toUpperCase()
    };
    const cnpjMask = IMask(cnpjInput, cnpjMaskOptions);

    const cepInput = form.querySelector("#Cep");
    const cepMaskOptions = {
        mask: "00000-000",
    };
    const cepMask = IMask(cepInput, cepMaskOptions);

    const telInput = form.querySelector("#Telefone");

    const telMaskOptions = {
        mask: "(00) 00000-0000",
    };
    const telMask = IMask(telInput, telMaskOptions);

    },

    preencherEnderecoViaCep(form) {
    document.getElementById("Cep").addEventListener("change", function (e) {
        buscaCep(this.value, form);
    });
    },
    getCidadesEstadosPeloPais(form) {
    const paisInput = form.querySelector("#paisID");
    paisInput.addEventListener("change", function (e) {
        let valorSelecionadoEstadoID = "[Selecione um país]";

        selectCidades(
        "estados",
        e.target.value,
        document.getElementById("estadoID"),
        valorSelecionadoEstadoID
        );
    });

    document
        .getElementById("estadoID")
        .addEventListener("change", function (e) {
        let valorSelecionadoCidadeID = "[Selecione um Estado]";

        selectCidades(
            "cidades",
            e.target.value,
            document.getElementById("cidadeID"),
            valorSelecionadoCidadeID
        );
        });

    paisInput.value = "BR";
    paisInput.dispatchEvent(new Event("change"));
    },
    async selectSegmentos() {
        const { default: TomSelect } = await import('tom-select');

        new TomSelect("#segmentos", {
            create: false,
            sortField: {
                field: "text",
                direction: "asc"
            },
            hidePlaceholder: true
        });
    },
    init(form) {
    inicializarInternacionalizacao();
    this.maskConfig(form);
    this.getCidadesEstadosPeloPais(form);
    this.preencherEnderecoViaCep(form);
    this.justValidateConfig(form);
        this.selectSegmentos();
    },
};
const empresaClienteExpress = {
    async salvar(form) {
    const formData = new FormData(form);

    const callbackSucesso = () => {
        window.location.href =
        "/" + CULTURE_EMPREGARE + "/empresa/cadastro-recebido";
    };

    const callbackErroConexao = () => {
        loadFullPage.esconder();
    };

    const callbackErro = (resultado) => {
        loadFullPage.esconder();

        Report.init({
        failure: {
            svgColor: "#ff5549",
            titleColor: "#1e1e1e",
            messageColor: "#242424",
            buttonBackground: "#ff5549",
            buttonColor: "#fff",
            backOverlayColor: "rgba(225,225,245,.4)",
        },
        });
        Report.failure("Ocorreu um erro", resultado.mensagem, "Ok");
    };

    loadFullPage.mostrar();


    const dialCode = getNumeroDialCodePorHtmlIntlTel("Telefone");
    formData.append("CodigoPaisTelefone", "+" + dialCode);

    await postFetch(
        `/${CULTURE_EMPREGARE}/HotSiteEmpresa/RegisterExpress`,
        formData,
        callbackSucesso,
        callbackErro,
        callbackErroConexao
    );
    },
    maskConfig(form) {
    const cpfInput = form.querySelector("#ResponsavelCpf");
    const cpfMaskOptions = {
        mask: "000.000.000-00",
    };
    const cpfMask = IMask(cpfInput, cpfMaskOptions);

    const cnpjInput = form.querySelector("#CpfCnpj");
    const cnpjMaskOptions = {
        mask: "SS.SSS.SSS/SSSS-00",
        definitions: { S: /[A-Za-z0-9]/ },
        prepare: (str) => str.toUpperCase()
    };
    const cnpjMask = IMask(cnpjInput, cnpjMaskOptions);

    const cepInput = form.querySelector("#Cep");
    const cepMaskOptions = {
        mask: "00000-000",
    };
    const cepMask = IMask(cepInput, cepMaskOptions);

    },
    justValidateConfig(form) {
    // Começo da validaocao de cada tab
    const validacaoResponsavel = (formValidarResponsavel) => {
        formValidarResponsavel
        .addField("#Responsavel", [
            { rule: "required", errorMessage: i18next.t('FormValidationResponsavelRequired')},
            {
            rule: "maxLength",
            value: 100,
            errorMessage: i18next.t('FormValidationResponsavelMax'),
            },
        ])
        .addField("#Cargo", [
            { rule: "required", errorMessage: i18next.t('FormValidationCargoRequired')},
            {
                rule: "maxLength",
                value: 100,
                errorMessage: i18next.t('FormValidationResponsavelMax'),
            },
        ])
        .addField("#ResponsavelCpf", [
            { rule: "required", errorMessage: i18next.t('FormValidationResponsavelCPFRequired')},
            {
            rule: "maxLength",
            value: 14,
            errorMessage: i18next.t('FormValidationResponsavelCPFMax'),
            },
        ])
        .addField("#ResponsavelRG", [
            { rule: "required", errorMessage: i18next.t('FormValidationResposavelRGRequired')},
            {
            rule: "maxLength",
            value: 18,
            errorMessage: i18next.t('FormValidationResponsavelRGMax'),
            },
        ])
        .addField("#Email", [
            { rule: "required", errorMessage: i18next.t('FormValidationEmailRequired')},
            {
            rule: "email",
            errorMessage: i18next.t('FormValidationEmailInvalid'),
            },
        ])
        .addField("#email-confirmar", [
            { rule: "required", errorMessage: i18next.t('FormValidationEmailRequired')},
            {
            rule: "email",
            errorMessage: i18next.t('FormValidationEmailInvalid'),
            },
            {
            validator: (value, context) =>
                value === document.getElementById("Email").value ? true : false,
            errorMessage: i18next.t('FormValidationEmailNaoConicidem'),
            },
        ]);

    
    };
    const validacaoEndereco = (formValidar) => {
        formValidar
        .addField("#paisID", [
            { rule: "required", errorMessage: i18next.t('FormValidationPaisRequired')},
        ])
        .addField("#estadoID", [
            { rule: "required", errorMessage: i18next.t('FormValidationEstadoRequired')},
        ])
        .addField("#cidadeID", [
            { rule: "required", errorMessage: i18next.t('FormValidationCidadeRequired')},
        ])
        .addField("#Cep", [
            { rule: "required", errorMessage: i18next.t('FormValidationCEPRequired')},
        ]);

        const btnsAvancarResponsavel = form.querySelector(
        "#btn-avancar-responsavel"
        );

        btnsAvancarResponsavel.addEventListener("click", () => {
        formValidar.revalidate().then((isValid) => {
            if (!isValid) return;

            const btnTabResponsavel = document.querySelector(
            btnsAvancarResponsavel.getAttribute("data-next")
            );
            btnTabResponsavel.classList.remove("disabled");
            btnTabResponsavel.parentNode.classList.remove("disabled");
            btnTabResponsavel.click();
            validacaoResponsavel(formValidar);

            btnsAvancarResponsavel.addEventListener("click", () => {
            btnTabResponsavel.click();
            });
        });
        });
    };

    const formValidar = new JustValidate(form, {
        errorFieldCssClass: "is-invalid",
    });

    if(document.getElementById("Razao")){
        formValidar.addField("#Razao", [
            { rule: "required", errorMessage: i18next.t('FormValidationRazaoRequired')},
            {
                rule: "maxLength",
                value: 150,
                errorMessage: i18next.t('FormValidationRazaoMax'),
            },
        ]);
    }

    if(document.getElementById("Nome")){
        formValidar.addField("#Nome", [
            { rule: "required", errorMessage: i18next.t('FormValidationNomeEmpresaRequired')},
            {
                rule: "maxLength",
                value: 150,
                errorMessage: i18next.t('FormValidationNomeEmpresaMax'),
            },
        ]);
    }

    formValidar
        .addField("#CpfCnpj", [
        { rule: "required", errorMessage: i18next.t('FormValidationCNPJRequired')},
        {
            rule: "maxLength",
            value: 18,
            errorMessage: i18next.t('FormValidationNomeCNPJMax'),
        },
        ]);
        
    formValidar
        .addField("#Numerofuncionarios", [
        { rule: "required", errorMessage: i18next.t('FormValidationNumeroFuncionariosRequired')},
        ]);
    
    if(document.getElementById("aceitar-contrato")){
        formValidar.addField("#aceitar-contrato", [
            { rule: "required", errorMessage: i18next.t('FormValidationTermosRequired')},
        ]);
    }
    const inputTelefoneElement = form.querySelector("#Telefone");

    configurarTelefoneInput(inputTelefoneElement,formValidar,"container-telefone", null, true);


    const btnsAvancarEndereco = form.querySelector("#btn-avancar-endereco");

    btnsAvancarEndereco.addEventListener("click", () => {
        formValidar.revalidate().then((isValid) => {
        if (!isValid) return;

        const btnTabEndereco = document.querySelector(
            btnsAvancarEndereco.getAttribute("data-next")
        );
        btnTabEndereco.classList.remove("disabled");
        btnTabEndereco.parentNode.classList.remove("disabled");
        btnTabEndereco.click();
        validacaoEndereco(formValidar);

        btnsAvancarEndereco.addEventListener("click", () => {
            btnTabEndereco.click();
        });
        });
    });

    form.addEventListener("submit", (e) => {
        e.preventDefault();

        formValidar.revalidate().then((isValid) => {
        if (!isValid) {
            const invalidFields = form.querySelectorAll(".is-invalid");
            const tabTarget = invalidFields[0].closest(".tab-pane");
            const btnTabTarget = document.querySelector(
            "#" + tabTarget.getAttribute("aria-labelledby")
            );
            btnTabTarget.click();
            return;
        }
        this.salvar(form);
        });
    });
    },
    preencherEnderecoViaCep(form) {
        document.getElementById("Cep").addEventListener("change", function (e) {
            buscaCep(this.value, form);
        });
    },
    preencherDadosViaCnpj(form) {
        document.getElementById("CpfCnpj").addEventListener("change", function (e) {
            buscaCnpj(this.value, form);
        });
    },
    getCidadesEstadosPeloPais(form) {
        const paisInput = form.querySelector("#paisID");
        paisInput.addEventListener("change", function (e) {
            let valorSelecionadoEstadoID = "[Selecione um país]";

            selectCidades(
            "estados",
            e.target.value,
            document.getElementById("estadoID"),
            valorSelecionadoEstadoID
            );
        });

        const estadoInput =  document.getElementById("estadoID");
        
        const tomSelectCidade = selectCidadesTomSelect(
            "cidades",
            estadoInput,
            document.getElementById("cidadeID")
        );

        paisInput.value = "BR";
        paisInput.dispatchEvent(new Event("change"));
    },
    init(form) {
    inicializarInternacionalizacao();
    this.maskConfig(form);
    this.getCidadesEstadosPeloPais(form);
    this.preencherEnderecoViaCep(form);
    this.preencherDadosViaCnpj(form);
    this.justValidateConfig(form);
    },
};

const formCadastrarExpress = document.getElementById("form-cadastrar-empresa");
if (formCadastrarExpress != null)
    empresaClienteExpress.init(formCadastrarExpress);

const formCadastrarEmpresa = document.getElementById("form-cadastrar-cliente");
if (formCadastrarEmpresa != null) empresaCliente.init(formCadastrarEmpresa);
